// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/audit/v1/audit.proto" (package "agency.audit.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { Claims } from "../../auth/v1/auth";
import { RBACRole } from "../../auth/v1/auth";
import { NodeID } from "../../address/v1/address";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * AuditEvent represents a compliance audit event.
 *
 * @generated from protobuf message agency.audit.v1.AuditEvent
 */
export interface AuditEvent {
    /**
     * event_id uniquely identifies this audit event.
     *
     * @generated from protobuf field: string event_id = 1
     */
    eventId: string;
    /**
     * event_type classifies the event.
     *
     * @generated from protobuf field: agency.audit.v1.AuditEventType event_type = 2
     */
    eventType: AuditEventType;
    /**
     * timestamp is when the event occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 3
     */
    timestamp?: Timestamp;
    /**
     * actor identifies who performed the action.
     *
     * @generated from protobuf field: agency.audit.v1.Actor actor = 4
     */
    actor?: Actor;
    /**
     * resource identifies what was accessed or modified.
     *
     * @generated from protobuf field: agency.audit.v1.Resource resource = 5
     */
    resource?: Resource;
    /**
     * action describes what was done.
     *
     * @generated from protobuf field: string action = 6
     */
    action: string;
    /**
     * outcome indicates success or failure.
     *
     * @generated from protobuf field: agency.audit.v1.AuditOutcome outcome = 7
     */
    outcome: AuditOutcome;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 8
     */
    tenant: string;
    /**
     * workspace is the workspace context (if applicable).
     *
     * @generated from protobuf field: string workspace = 9
     */
    workspace: string;
    /**
     * session_id is the session context (if applicable).
     *
     * @generated from protobuf field: string session_id = 10
     */
    sessionId: string;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 11
     */
    traceId: string;
    /**
     * metadata contains additional event context.
     *
     * @generated from protobuf field: map<string, string> metadata = 12
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * reason provides additional context for failures or rejections.
     *
     * @generated from protobuf field: string reason = 13
     */
    reason: string;
    /**
     * ip_address is the source IP (if applicable).
     *
     * @generated from protobuf field: string ip_address = 14
     */
    ipAddress: string;
    /**
     * user_agent is the client user agent (if applicable).
     *
     * @generated from protobuf field: string user_agent = 15
     */
    userAgent: string;
    /**
     * node identifies the harness node.
     *
     * @generated from protobuf field: agency.address.v1.NodeID node = 16
     */
    node?: NodeID;
    /**
     * compliance_tags are tags for compliance filtering.
     *
     * @generated from protobuf field: repeated string compliance_tags = 17
     */
    complianceTags: string[];
}
/**
 * Actor identifies who performed an action.
 *
 * @generated from protobuf message agency.audit.v1.Actor
 */
export interface Actor {
    /**
     * type is the actor type.
     *
     * @generated from protobuf field: agency.audit.v1.ActorType type = 1
     */
    type: ActorType;
    /**
     * id is the actor identifier.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * role is the RBAC role (if applicable).
     *
     * @generated from protobuf field: agency.auth.v1.RBACRole role = 3
     */
    role: RBACRole;
    /**
     * claims are the authentication claims (if applicable).
     *
     * @generated from protobuf field: agency.auth.v1.Claims claims = 4
     */
    claims?: Claims;
}
/**
 * Resource identifies what was accessed or modified.
 *
 * @generated from protobuf message agency.audit.v1.Resource
 */
export interface Resource {
    /**
     * type is the resource type.
     *
     * @generated from protobuf field: agency.audit.v1.ResourceType type = 1
     */
    type: ResourceType;
    /**
     * id is the resource identifier.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * attributes are resource-specific details.
     *
     * @generated from protobuf field: map<string, string> attributes = 3
     */
    attributes: {
        [key: string]: string;
    };
}
/**
 * CompliancePolicy defines retention and export policies.
 *
 * @generated from protobuf message agency.audit.v1.CompliancePolicy
 */
export interface CompliancePolicy {
    /**
     * policy_id uniquely identifies this policy.
     *
     * @generated from protobuf field: string policy_id = 1
     */
    policyId: string;
    /**
     * name is the human-readable policy name.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * retention_period is how long to retain audit events.
     *
     * @generated from protobuf field: google.protobuf.Duration retention_period = 3
     */
    retentionPeriod?: Duration;
    /**
     * event_types are the event types covered by this policy.
     *
     * @generated from protobuf field: repeated agency.audit.v1.AuditEventType event_types = 4
     */
    eventTypes: AuditEventType[];
    /**
     * export_enabled enables SIEM export.
     *
     * @generated from protobuf field: bool export_enabled = 5
     */
    exportEnabled: boolean;
    /**
     * export_endpoint is the SIEM endpoint.
     *
     * @generated from protobuf field: string export_endpoint = 6
     */
    exportEndpoint: string;
    /**
     * export_batch_size is the export batch size.
     *
     * @generated from protobuf field: int32 export_batch_size = 7
     */
    exportBatchSize: number;
    /**
     * export_interval is the export frequency.
     *
     * @generated from protobuf field: google.protobuf.Duration export_interval = 8
     */
    exportInterval?: Duration;
    /**
     * immutable prevents modification after creation.
     *
     * @generated from protobuf field: bool immutable = 9
     */
    immutable: boolean;
    /**
     * compliance_tags identify regulatory requirements.
     *
     * @generated from protobuf field: repeated string compliance_tags = 10
     */
    complianceTags: string[];
}
/**
 * AuditQuery requests audit events matching criteria.
 *
 * @generated from protobuf message agency.audit.v1.AuditQuery
 */
export interface AuditQuery {
    /**
     * tenant filters by tenant.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace filters by workspace.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id filters by session.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * event_types filters by event types.
     *
     * @generated from protobuf field: repeated agency.audit.v1.AuditEventType event_types = 4
     */
    eventTypes: AuditEventType[];
    /**
     * actor_id filters by actor.
     *
     * @generated from protobuf field: string actor_id = 5
     */
    actorId: string;
    /**
     * start_time is the query start time.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 6
     */
    startTime?: Timestamp;
    /**
     * end_time is the query end time.
     *
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 7
     */
    endTime?: Timestamp;
    /**
     * limit is the maximum results to return.
     *
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * offset is the pagination offset.
     *
     * @generated from protobuf field: int32 offset = 9
     */
    offset: number;
    /**
     * compliance_tags filters by compliance tags.
     *
     * @generated from protobuf field: repeated string compliance_tags = 10
     */
    complianceTags: string[];
}
/**
 * AuditQueryResponse returns matching audit events.
 *
 * @generated from protobuf message agency.audit.v1.AuditQueryResponse
 */
export interface AuditQueryResponse {
    /**
     * events are the matching audit events.
     *
     * @generated from protobuf field: repeated agency.audit.v1.AuditEvent events = 1
     */
    events: AuditEvent[];
    /**
     * total_count is the total matching events (for pagination).
     *
     * @generated from protobuf field: int32 total_count = 2
     */
    totalCount: number;
    /**
     * has_more indicates if more results are available.
     *
     * @generated from protobuf field: bool has_more = 3
     */
    hasMore: boolean;
}
/**
 * ExportRequest is a batch of events for SIEM export.
 *
 * @generated from protobuf message agency.audit.v1.ExportRequest
 */
export interface ExportRequest {
    /**
     * batch_id uniquely identifies this export batch.
     *
     * @generated from protobuf field: string batch_id = 1
     */
    batchId: string;
    /**
     * events are the audit events to export.
     *
     * @generated from protobuf field: repeated agency.audit.v1.AuditEvent events = 2
     */
    events: AuditEvent[];
    /**
     * export_format is the target format (json, cef, leef, syslog).
     *
     * @generated from protobuf field: string export_format = 3
     */
    exportFormat: string;
    /**
     * policy_id is the compliance policy governing this export.
     *
     * @generated from protobuf field: string policy_id = 4
     */
    policyId: string;
    /**
     * exported_at is when this batch was exported.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exported_at = 5
     */
    exportedAt?: Timestamp;
}
/**
 * ExportResponse confirms export completion.
 *
 * @generated from protobuf message agency.audit.v1.ExportResponse
 */
export interface ExportResponse {
    /**
     * batch_id identifies the exported batch.
     *
     * @generated from protobuf field: string batch_id = 1
     */
    batchId: string;
    /**
     * events_exported is the count of successfully exported events.
     *
     * @generated from protobuf field: int32 events_exported = 2
     */
    eventsExported: number;
    /**
     * events_failed is the count of failed exports.
     *
     * @generated from protobuf field: int32 events_failed = 3
     */
    eventsFailed: number;
    /**
     * export_endpoint is where the events were sent.
     *
     * @generated from protobuf field: string export_endpoint = 4
     */
    exportEndpoint: string;
    /**
     * exported_at is when the export completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exported_at = 5
     */
    exportedAt?: Timestamp;
}
/**
 * HealthCheckRequest checks SIEM connectivity.
 *
 * @generated from protobuf message agency.audit.v1.HealthCheckRequest
 */
export interface HealthCheckRequest {
    /**
     * endpoint is the SIEM endpoint to check.
     *
     * @generated from protobuf field: string endpoint = 1
     */
    endpoint: string;
}
/**
 * HealthCheckResponse returns SIEM health status.
 *
 * @generated from protobuf message agency.audit.v1.HealthCheckResponse
 */
export interface HealthCheckResponse {
    /**
     * healthy indicates if the SIEM is reachable.
     *
     * @generated from protobuf field: bool healthy = 1
     */
    healthy: boolean;
    /**
     * latency_ms is the connection latency.
     *
     * @generated from protobuf field: int64 latency_ms = 2
     */
    latencyMs: bigint;
    /**
     * error_message describes any connection issues.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * AuditEventType classifies audit events.
 *
 * @generated from protobuf enum agency.audit.v1.AuditEventType
 */
export enum AuditEventType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SESSION_STARTED indicates session creation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_SESSION_STARTED = 1;
     */
    SESSION_STARTED = 1,
    /**
     * SESSION_COMPLETED indicates successful session completion.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_SESSION_COMPLETED = 2;
     */
    SESSION_COMPLETED = 2,
    /**
     * SESSION_FAILED indicates session failure.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_SESSION_FAILED = 3;
     */
    SESSION_FAILED = 3,
    /**
     * SESSION_CANCELLED indicates session cancellation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_SESSION_CANCELLED = 4;
     */
    SESSION_CANCELLED = 4,
    /**
     * TOOL_EXECUTED indicates tool execution.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_TOOL_EXECUTED = 5;
     */
    TOOL_EXECUTED = 5,
    /**
     * TOOL_REJECTED indicates security gate rejection.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_TOOL_REJECTED = 6;
     */
    TOOL_REJECTED = 6,
    /**
     * LLM_CALLED indicates LLM inference.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_LLM_CALLED = 7;
     */
    LLM_CALLED = 7,
    /**
     * CREDENTIAL_ACCESSED indicates credential fetch.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_CREDENTIAL_ACCESSED = 8;
     */
    CREDENTIAL_ACCESSED = 8,
    /**
     * QUOTA_EXCEEDED indicates quota limit violation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_QUOTA_EXCEEDED = 9;
     */
    QUOTA_EXCEEDED = 9,
    /**
     * RATE_LIMITED indicates rate limit violation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_RATE_LIMITED = 10;
     */
    RATE_LIMITED = 10,
    /**
     * AUTH_FAILED indicates authentication failure.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_AUTH_FAILED = 11;
     */
    AUTH_FAILED = 11,
    /**
     * AUTH_SUCCEEDED indicates successful authentication.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_AUTH_SUCCEEDED = 12;
     */
    AUTH_SUCCEEDED = 12,
    /**
     * KEY_REGISTERED indicates encryption key registration.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_KEY_REGISTERED = 13;
     */
    KEY_REGISTERED = 13,
    /**
     * KEY_REVOKED indicates encryption key revocation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_KEY_REVOKED = 14;
     */
    KEY_REVOKED = 14,
    /**
     * SKILL_EXECUTED indicates skill sandbox execution.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_SKILL_EXECUTED = 15;
     */
    SKILL_EXECUTED = 15,
    /**
     * HOOK_EXECUTED indicates hook execution.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_HOOK_EXECUTED = 16;
     */
    HOOK_EXECUTED = 16,
    /**
     * HOOK_BLOCKED indicates hook rejection.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_HOOK_BLOCKED = 17;
     */
    HOOK_BLOCKED = 17,
    /**
     * CONTEXT_ACCESSED indicates context retrieval.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_CONTEXT_ACCESSED = 18;
     */
    CONTEXT_ACCESSED = 18,
    /**
     * FEDERATION_REQUEST indicates cross-harness request.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_FEDERATION_REQUEST = 19;
     */
    FEDERATION_REQUEST = 19,
    /**
     * GDPR_ERASURE indicates data erasure request.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_GDPR_ERASURE = 20;
     */
    GDPR_ERASURE = 20,
    /**
     * POLICY_VIOLATION indicates policy violation.
     *
     * @generated from protobuf enum value: AUDIT_EVENT_TYPE_POLICY_VIOLATION = 21;
     */
    POLICY_VIOLATION = 21
}
/**
 * ActorType classifies actors.
 *
 * @generated from protobuf enum agency.audit.v1.ActorType
 */
export enum ActorType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * USER is a human user.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * SERVICE is a service account.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_SERVICE = 2;
     */
    SERVICE = 2,
    /**
     * SYSTEM is the harness system.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_SYSTEM = 3;
     */
    SYSTEM = 3,
    /**
     * AGENT is an autonomous agent/session.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_AGENT = 4;
     */
    AGENT = 4,
    /**
     * FEDERATED is a remote harness.
     *
     * @generated from protobuf enum value: ACTOR_TYPE_FEDERATED = 5;
     */
    FEDERATED = 5
}
/**
 * ResourceType classifies resources.
 *
 * @generated from protobuf enum agency.audit.v1.ResourceType
 */
export enum ResourceType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SESSION is a session resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_SESSION = 1;
     */
    SESSION = 1,
    /**
     * TOOL is a tool resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_TOOL = 2;
     */
    TOOL = 2,
    /**
     * CREDENTIAL is a credential resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_CREDENTIAL = 3;
     */
    CREDENTIAL = 3,
    /**
     * MODEL is an LLM model resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_MODEL = 4;
     */
    MODEL = 4,
    /**
     * WORKSPACE is a workspace resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_WORKSPACE = 5;
     */
    WORKSPACE = 5,
    /**
     * TENANT is a tenant resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_TENANT = 6;
     */
    TENANT = 6,
    /**
     * SKILL is a skill resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_SKILL = 7;
     */
    SKILL = 7,
    /**
     * CONTEXT is a context resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_CONTEXT = 8;
     */
    CONTEXT = 8,
    /**
     * KEY is an encryption key resource.
     *
     * @generated from protobuf enum value: RESOURCE_TYPE_KEY = 9;
     */
    KEY = 9
}
/**
 * AuditOutcome indicates success or failure.
 *
 * @generated from protobuf enum agency.audit.v1.AuditOutcome
 */
export enum AuditOutcome {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: AUDIT_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SUCCESS indicates successful operation.
     *
     * @generated from protobuf enum value: AUDIT_OUTCOME_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * FAILURE indicates operation failure.
     *
     * @generated from protobuf enum value: AUDIT_OUTCOME_FAILURE = 2;
     */
    FAILURE = 2,
    /**
     * DENIED indicates authorization denial.
     *
     * @generated from protobuf enum value: AUDIT_OUTCOME_DENIED = 3;
     */
    DENIED = 3,
    /**
     * PARTIAL indicates partial success.
     *
     * @generated from protobuf enum value: AUDIT_OUTCOME_PARTIAL = 4;
     */
    PARTIAL = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class AuditEvent$Type extends MessageType<AuditEvent> {
    constructor() {
        super("agency.audit.v1.AuditEvent", [
            { no: 1, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "event_type", kind: "enum", T: () => ["agency.audit.v1.AuditEventType", AuditEventType, "AUDIT_EVENT_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "actor", kind: "message", T: () => Actor, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "resource", kind: "message", T: () => Resource, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "action", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 7, name: "outcome", kind: "enum", T: () => ["agency.audit.v1.AuditOutcome", AuditOutcome, "AUDIT_OUTCOME_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 9, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 10, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 11, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{32})?$" } } } },
            { no: 12, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 13, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 14, name: "ip_address", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "45" } } } },
            { no: 15, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 16, name: "node", kind: "message", T: () => NodeID },
            { no: 17, name: "compliance_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AuditEvent>): AuditEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.eventId = "";
        message.eventType = 0;
        message.action = "";
        message.outcome = 0;
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.traceId = "";
        message.metadata = {};
        message.reason = "";
        message.ipAddress = "";
        message.userAgent = "";
        message.complianceTags = [];
        if (value !== undefined)
            reflectionMergePartial<AuditEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditEvent): AuditEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id */ 1:
                    message.eventId = reader.string();
                    break;
                case /* agency.audit.v1.AuditEventType event_type */ 2:
                    message.eventType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 3:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* agency.audit.v1.Actor actor */ 4:
                    message.actor = Actor.internalBinaryRead(reader, reader.uint32(), options, message.actor);
                    break;
                case /* agency.audit.v1.Resource resource */ 5:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* string action */ 6:
                    message.action = reader.string();
                    break;
                case /* agency.audit.v1.AuditOutcome outcome */ 7:
                    message.outcome = reader.int32();
                    break;
                case /* string tenant */ 8:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 9:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 10:
                    message.sessionId = reader.string();
                    break;
                case /* string trace_id */ 11:
                    message.traceId = reader.string();
                    break;
                case /* map<string, string> metadata */ 12:
                    this.binaryReadMap12(message.metadata, reader, options);
                    break;
                case /* string reason */ 13:
                    message.reason = reader.string();
                    break;
                case /* string ip_address */ 14:
                    message.ipAddress = reader.string();
                    break;
                case /* string user_agent */ 15:
                    message.userAgent = reader.string();
                    break;
                case /* agency.address.v1.NodeID node */ 16:
                    message.node = NodeID.internalBinaryRead(reader, reader.uint32(), options, message.node);
                    break;
                case /* repeated string compliance_tags */ 17:
                    message.complianceTags.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: AuditEvent["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AuditEvent["metadata"] | undefined, val: AuditEvent["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.audit.v1.AuditEvent.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: AuditEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        /* agency.audit.v1.AuditEventType event_type = 2; */
        if (message.eventType !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventType);
        /* google.protobuf.Timestamp timestamp = 3; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.audit.v1.Actor actor = 4; */
        if (message.actor)
            Actor.internalBinaryWrite(message.actor, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.audit.v1.Resource resource = 5; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string action = 6; */
        if (message.action !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.action);
        /* agency.audit.v1.AuditOutcome outcome = 7; */
        if (message.outcome !== 0)
            writer.tag(7, WireType.Varint).int32(message.outcome);
        /* string tenant = 8; */
        if (message.tenant !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 9; */
        if (message.workspace !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 10; */
        if (message.sessionId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.sessionId);
        /* string trace_id = 11; */
        if (message.traceId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.traceId);
        /* map<string, string> metadata = 12; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string reason = 13; */
        if (message.reason !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.reason);
        /* string ip_address = 14; */
        if (message.ipAddress !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.ipAddress);
        /* string user_agent = 15; */
        if (message.userAgent !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.userAgent);
        /* agency.address.v1.NodeID node = 16; */
        if (message.node)
            NodeID.internalBinaryWrite(message.node, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated string compliance_tags = 17; */
        for (let i = 0; i < message.complianceTags.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.complianceTags[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.AuditEvent
 */
export const AuditEvent = new AuditEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Actor$Type extends MessageType<Actor> {
    constructor() {
        super("agency.audit.v1.Actor", [
            { no: 1, name: "type", kind: "enum", T: () => ["agency.audit.v1.ActorType", ActorType, "ACTOR_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "role", kind: "enum", T: () => ["agency.auth.v1.RBACRole", RBACRole] },
            { no: 4, name: "claims", kind: "message", T: () => Claims }
        ]);
    }
    create(value?: PartialMessage<Actor>): Actor {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.id = "";
        message.role = 0;
        if (value !== undefined)
            reflectionMergePartial<Actor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Actor): Actor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.audit.v1.ActorType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* agency.auth.v1.RBACRole role */ 3:
                    message.role = reader.int32();
                    break;
                case /* agency.auth.v1.Claims claims */ 4:
                    message.claims = Claims.internalBinaryRead(reader, reader.uint32(), options, message.claims);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Actor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.audit.v1.ActorType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* agency.auth.v1.RBACRole role = 3; */
        if (message.role !== 0)
            writer.tag(3, WireType.Varint).int32(message.role);
        /* agency.auth.v1.Claims claims = 4; */
        if (message.claims)
            Claims.internalBinaryWrite(message.claims, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.Actor
 */
export const Actor = new Actor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Resource$Type extends MessageType<Resource> {
    constructor() {
        super("agency.audit.v1.Resource", [
            { no: 1, name: "type", kind: "enum", T: () => ["agency.audit.v1.ResourceType", ResourceType, "RESOURCE_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<Resource>): Resource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.id = "";
        message.attributes = {};
        if (value !== undefined)
            reflectionMergePartial<Resource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Resource): Resource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.audit.v1.ResourceType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* map<string, string> attributes */ 3:
                    this.binaryReadMap3(message.attributes, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: Resource["attributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Resource["attributes"] | undefined, val: Resource["attributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.audit.v1.Resource.attributes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Resource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.audit.v1.ResourceType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* map<string, string> attributes = 3; */
        for (let k of globalThis.Object.keys(message.attributes))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.attributes[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.Resource
 */
export const Resource = new Resource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompliancePolicy$Type extends MessageType<CompliancePolicy> {
    constructor() {
        super("agency.audit.v1.CompliancePolicy", [
            { no: 1, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "retention_period", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "event_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.audit.v1.AuditEventType", AuditEventType, "AUDIT_EVENT_TYPE_"], options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "50" } } } },
            { no: 5, name: "export_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "export_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 7, name: "export_batch_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } },
            { no: 8, name: "export_interval", kind: "message", T: () => Duration },
            { no: 9, name: "immutable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "compliance_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<CompliancePolicy>): CompliancePolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policyId = "";
        message.name = "";
        message.eventTypes = [];
        message.exportEnabled = false;
        message.exportEndpoint = "";
        message.exportBatchSize = 0;
        message.immutable = false;
        message.complianceTags = [];
        if (value !== undefined)
            reflectionMergePartial<CompliancePolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompliancePolicy): CompliancePolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string policy_id */ 1:
                    message.policyId = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Duration retention_period */ 3:
                    message.retentionPeriod = Duration.internalBinaryRead(reader, reader.uint32(), options, message.retentionPeriod);
                    break;
                case /* repeated agency.audit.v1.AuditEventType event_types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.eventTypes.push(reader.int32());
                    else
                        message.eventTypes.push(reader.int32());
                    break;
                case /* bool export_enabled */ 5:
                    message.exportEnabled = reader.bool();
                    break;
                case /* string export_endpoint */ 6:
                    message.exportEndpoint = reader.string();
                    break;
                case /* int32 export_batch_size */ 7:
                    message.exportBatchSize = reader.int32();
                    break;
                case /* google.protobuf.Duration export_interval */ 8:
                    message.exportInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.exportInterval);
                    break;
                case /* bool immutable */ 9:
                    message.immutable = reader.bool();
                    break;
                case /* repeated string compliance_tags */ 10:
                    message.complianceTags.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompliancePolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string policy_id = 1; */
        if (message.policyId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.policyId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Duration retention_period = 3; */
        if (message.retentionPeriod)
            Duration.internalBinaryWrite(message.retentionPeriod, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.audit.v1.AuditEventType event_types = 4; */
        if (message.eventTypes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.eventTypes.length; i++)
                writer.int32(message.eventTypes[i]);
            writer.join();
        }
        /* bool export_enabled = 5; */
        if (message.exportEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.exportEnabled);
        /* string export_endpoint = 6; */
        if (message.exportEndpoint !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.exportEndpoint);
        /* int32 export_batch_size = 7; */
        if (message.exportBatchSize !== 0)
            writer.tag(7, WireType.Varint).int32(message.exportBatchSize);
        /* google.protobuf.Duration export_interval = 8; */
        if (message.exportInterval)
            Duration.internalBinaryWrite(message.exportInterval, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool immutable = 9; */
        if (message.immutable !== false)
            writer.tag(9, WireType.Varint).bool(message.immutable);
        /* repeated string compliance_tags = 10; */
        for (let i = 0; i < message.complianceTags.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.complianceTags[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.CompliancePolicy
 */
export const CompliancePolicy = new CompliancePolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditQuery$Type extends MessageType<AuditQuery> {
    constructor() {
        super("agency.audit.v1.AuditQuery", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "event_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.audit.v1.AuditEventType", AuditEventType, "AUDIT_EVENT_TYPE_"], options: { "buf.validate.field": { repeated: { maxItems: "20" } } } },
            { no: 5, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 6, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } },
            { no: 9, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 10, name: "compliance_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AuditQuery>): AuditQuery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.eventTypes = [];
        message.actorId = "";
        message.limit = 0;
        message.offset = 0;
        message.complianceTags = [];
        if (value !== undefined)
            reflectionMergePartial<AuditQuery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditQuery): AuditQuery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* repeated agency.audit.v1.AuditEventType event_types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.eventTypes.push(reader.int32());
                    else
                        message.eventTypes.push(reader.int32());
                    break;
                case /* string actor_id */ 5:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_time */ 6:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 7:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* int32 offset */ 9:
                    message.offset = reader.int32();
                    break;
                case /* repeated string compliance_tags */ 10:
                    message.complianceTags.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditQuery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* repeated agency.audit.v1.AuditEventType event_types = 4; */
        if (message.eventTypes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.eventTypes.length; i++)
                writer.int32(message.eventTypes[i]);
            writer.join();
        }
        /* string actor_id = 5; */
        if (message.actorId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp start_time = 6; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 7; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* int32 offset = 9; */
        if (message.offset !== 0)
            writer.tag(9, WireType.Varint).int32(message.offset);
        /* repeated string compliance_tags = 10; */
        for (let i = 0; i < message.complianceTags.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.complianceTags[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.AuditQuery
 */
export const AuditQuery = new AuditQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditQueryResponse$Type extends MessageType<AuditQueryResponse> {
    constructor() {
        super("agency.audit.v1.AuditQueryResponse", [
            { no: 1, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuditEvent, options: { "buf.validate.field": { repeated: { maxItems: "10000" } } } },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AuditQueryResponse>): AuditQueryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.events = [];
        message.totalCount = 0;
        message.hasMore = false;
        if (value !== undefined)
            reflectionMergePartial<AuditQueryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditQueryResponse): AuditQueryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.audit.v1.AuditEvent events */ 1:
                    message.events.push(AuditEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* bool has_more */ 3:
                    message.hasMore = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditQueryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.audit.v1.AuditEvent events = 1; */
        for (let i = 0; i < message.events.length; i++)
            AuditEvent.internalBinaryWrite(message.events[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* bool has_more = 3; */
        if (message.hasMore !== false)
            writer.tag(3, WireType.Varint).bool(message.hasMore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.AuditQueryResponse
 */
export const AuditQueryResponse = new AuditQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportRequest$Type extends MessageType<ExportRequest> {
    constructor() {
        super("agency.audit.v1.ExportRequest", [
            { no: 1, name: "batch_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuditEvent, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10000" } } } },
            { no: 3, name: "export_format", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[a-z0-9_]+$" } } } },
            { no: 4, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 5, name: "exported_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ExportRequest>): ExportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batchId = "";
        message.events = [];
        message.exportFormat = "";
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<ExportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportRequest): ExportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string batch_id */ 1:
                    message.batchId = reader.string();
                    break;
                case /* repeated agency.audit.v1.AuditEvent events */ 2:
                    message.events.push(AuditEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string export_format */ 3:
                    message.exportFormat = reader.string();
                    break;
                case /* string policy_id */ 4:
                    message.policyId = reader.string();
                    break;
                case /* google.protobuf.Timestamp exported_at */ 5:
                    message.exportedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exportedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string batch_id = 1; */
        if (message.batchId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batchId);
        /* repeated agency.audit.v1.AuditEvent events = 2; */
        for (let i = 0; i < message.events.length; i++)
            AuditEvent.internalBinaryWrite(message.events[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string export_format = 3; */
        if (message.exportFormat !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.exportFormat);
        /* string policy_id = 4; */
        if (message.policyId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.policyId);
        /* google.protobuf.Timestamp exported_at = 5; */
        if (message.exportedAt)
            Timestamp.internalBinaryWrite(message.exportedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.ExportRequest
 */
export const ExportRequest = new ExportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportResponse$Type extends MessageType<ExportResponse> {
    constructor() {
        super("agency.audit.v1.ExportResponse", [
            { no: 1, name: "batch_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "events_exported", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "events_failed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "export_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 5, name: "exported_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ExportResponse>): ExportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batchId = "";
        message.eventsExported = 0;
        message.eventsFailed = 0;
        message.exportEndpoint = "";
        if (value !== undefined)
            reflectionMergePartial<ExportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportResponse): ExportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string batch_id */ 1:
                    message.batchId = reader.string();
                    break;
                case /* int32 events_exported */ 2:
                    message.eventsExported = reader.int32();
                    break;
                case /* int32 events_failed */ 3:
                    message.eventsFailed = reader.int32();
                    break;
                case /* string export_endpoint */ 4:
                    message.exportEndpoint = reader.string();
                    break;
                case /* google.protobuf.Timestamp exported_at */ 5:
                    message.exportedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exportedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string batch_id = 1; */
        if (message.batchId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batchId);
        /* int32 events_exported = 2; */
        if (message.eventsExported !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventsExported);
        /* int32 events_failed = 3; */
        if (message.eventsFailed !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventsFailed);
        /* string export_endpoint = 4; */
        if (message.exportEndpoint !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.exportEndpoint);
        /* google.protobuf.Timestamp exported_at = 5; */
        if (message.exportedAt)
            Timestamp.internalBinaryWrite(message.exportedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.ExportResponse
 */
export const ExportResponse = new ExportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckRequest$Type extends MessageType<HealthCheckRequest> {
    constructor() {
        super("agency.audit.v1.HealthCheckRequest", [
            { no: 1, name: "endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthCheckRequest>): HealthCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.endpoint = "";
        if (value !== undefined)
            reflectionMergePartial<HealthCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckRequest): HealthCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string endpoint */ 1:
                    message.endpoint = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string endpoint = 1; */
        if (message.endpoint !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.endpoint);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.HealthCheckRequest
 */
export const HealthCheckRequest = new HealthCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckResponse$Type extends MessageType<HealthCheckResponse> {
    constructor() {
        super("agency.audit.v1.HealthCheckResponse", [
            { no: 1, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "latency_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthCheckResponse>): HealthCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.healthy = false;
        message.latencyMs = 0n;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<HealthCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckResponse): HealthCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool healthy */ 1:
                    message.healthy = reader.bool();
                    break;
                case /* int64 latency_ms */ 2:
                    message.latencyMs = reader.int64().toBigInt();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool healthy = 1; */
        if (message.healthy !== false)
            writer.tag(1, WireType.Varint).bool(message.healthy);
        /* int64 latency_ms = 2; */
        if (message.latencyMs !== 0n)
            writer.tag(2, WireType.Varint).int64(message.latencyMs);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.audit.v1.HealthCheckResponse
 */
export const HealthCheckResponse = new HealthCheckResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.audit.v1.AuditExporterService
 */
export const AuditExporterService = new ServiceType("agency.audit.v1.AuditExporterService", [
    { name: "Export", options: {}, I: ExportRequest, O: ExportResponse },
    { name: "HealthCheck", options: {}, I: HealthCheckRequest, O: HealthCheckResponse }
]);
